export const isNonEmptyArray = (arr: unknown): arr is unknown[] =>
  Array.isArray(arr) && arr.length > 0

export function areUnorderedArraysSame<T extends string | number | boolean | null | undefined>(
  arr1: T[],
  arr2: T[]
): boolean {
  return [...arr1].sort().toString() === [...arr2].sort().toString()
}
